// src/pages/AboutUs.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {
  // Updated static image URL
  const aboutUsImage = "https://ziyaratguide.com/wp-content/uploads/2025/09/Al-Kadhimiya_Mosque_Kadhmain_Shrine-scaled.jpg";

  return (
    <>
      <Helmet>
        <title>About Us | Ziyarat Guide</title>
        <meta
          name="description"
          content="Learn about Ziyarat Guide — our mission to help pilgrims explore the sacred cities of Karbala and Najaf with clarity and respect. Discover shrine insights, travel tips, and guidance for a peaceful journey."
        />
        <meta property="og:title" content="About Us | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Ziyarat Guide provides pilgrims with trusted knowledge, shrine histories, and travel support for visiting Karbala and Najaf."
        />
        <meta property="og:image" content={aboutUsImage} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="page-container">
        <h1 className="page-title">About Ziyarat Guide</h1>

        <section className="content-section">
          <p>
            Ziyarat Guide exists to support anyone planning a spiritual journey to the sacred city of Karbala. If you’re visiting for the first time or returning as a seasoned pilgrim, you’ll find everything you need: clear explanations of each shrine’s historical and spiritual significance, practical tips, and thoughtful context to deepen your experience.
          </p>
          <p>
            We cover major shrines like:
          </p>
          <div className="flex flex-wrap justify-around items-start my-6 gap-6">
            <div className="flex-1 min-w-[280px] max-w-[400px]">
              <img
                src={aboutUsImage}
                alt="Al-Kadhimiya Mosque & Kadhmain Shrine"
                className="responsive-image mb-4"
              />
              <ul>
                <li><strong>The Shrine of Imam Hussain (PBUH)</strong></li>
                <li><strong>Al-Abbas (PBUH) Shrine</strong></li>
              </ul>
            </div>
            <div className="flex-1 min-w-[280px] max-w-[400px]">
              <ul>
                <li><strong>Shrine of the Two Sons of Muslim Ibn Aqeel</strong></li>
                <li><strong>Al-Mukhayam Shrine</strong> (marking the camp of Imam Hussain’s family before the battle)</li>
              </ul>
            </div>
          </div>

          <p className="mt-6">
            Beyond locations, we highlight pivotal moments such as <strong>Ashura</strong> and the <strong>Arbaeen pilgrimage</strong> — explaining their rituals, origins, and deep emotional significance for pilgrims.
          </p>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
